// // import React, { useCallback, useState } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { Document, Page, pdfjs } from "react-pdf";
// // import { useInView } from "react-intersection-observer";
// // import ChatBot from "./ChatBot";
// // import axios from "axios";
// // import Reading_loop from "../../assest/Nerdy Think Read GIF/Reading_Loop.mp4";
// // import { useDispatch } from "react-redux";
// // import { logout } from "../../features/auth/authSlice";

// // pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`;

// // const DocumentView = ({ dir }) => {
// //   const location = useLocation();
// //   const navigate = useNavigate();
// //   const dispatch = useDispatch();

// //   const documentUrl = location.state?.docUrl || null;
// //   const documentName = location.state?.name || null;
// //   const courseId = location.state?.courseId || null;
// //   const moduleId = location.state?.moduleId || null;
// //   const indexDoc = location.state?.index;

// //   const [loading, setLoading] = useState(true);
// //   const [numPages, setNumPages] = useState(null);
// //   const [pdfError, setPdfError] = useState(false);
// //   const [showChat, setShowChat] = useState(true);

// //   const handleSignOut = useCallback(() => {
// //     localStorage.removeItem("user");
// //     localStorage.removeItem("token");
// //     localStorage.removeItem("profileData");
// //     sessionStorage.removeItem("conversation");
// //     sessionStorage.removeItem("currentSessionId");
// //     sessionStorage.removeItem("sessionNumber");
// //     sessionStorage.removeItem("sessions");
// //     dispatch(logout());
// //     navigate("/login");
// //   }, [navigate, dispatch]);

// //   const handleComplete = async () => {
// //     try {
// //       const base_url = process.env.REACT_APP_LMS_APP_BASE_URL;
// //       const token = localStorage.getItem("token");
// //       const profileData = JSON.parse(localStorage.getItem("profileData"));
// //       const userId = profileData?.id;

// //       const response = await axios.put(
// //         `${base_url}/module/updateDocumentProgress`,
// //         {
// //           userId,
// //           moduleId,
// //           courseId,
// //           documentIndex: indexDoc,
// //           status: "completed",
// //           timeSpent: 300,
// //         },
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );

// //       console.log("Document progress updated successfully:", response.data);
// //       navigate(`/lms/dashboard/module`, { state: { moduleId } });
// //     } catch (error) {
// //       if (error?.response?.status === 401) handleSignOut();
// //       console.error("Error updating document progress:", error);
// //     }
// //   };

// //   if (!documentUrl) {
// //     return (
// //       <div className="text-center py-10 text-red-500">
// //         No document URL provided.
// //       </div>
// //     );
// //   }

// //   const ext = documentUrl.split(".").pop().toLowerCase();
// //   const isPDF = ext === "pdf";
// //   const isDoc = ext === "doc" || ext === "docx";
// //   const isPpt = ext === "ppt" || ext === "pptx";

// //   // Helper component for lazy loading pages
// //   const LazyPage = ({ pageNumber }) => {
// //     const { ref, inView } = useInView({
// //       threshold: 0.1,
// //       triggerOnce: true,
// //     });

// //     return (
// //       <div ref={ref} className="mb-2 flex justify-center">
// //         {inView ? <Page pageNumber={pageNumber} width={700} /> : <div style={{ height: 900 }} />}
// //       </div>
// //     );
// //   };

// //   return (
// //     <div dir={dir} className="flex flex-col md:flex-row h-[85vh] ml-16">
// //       {/* Document Viewer */}
// //       <div className="flex-1 flex flex-col">
// //         <header className="bg-white/80 backdrop-blur-xl border-b border-gray-200/50 pb-6 z-10">
// //           <div className="flex items-center gap-4">
// //             <button
// //               onClick={() => navigate(-1)}
// //               style={{ backgroundColor: "#767676" }}
// //               className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center transition-all duration-300 cursor-pointer"
// //             >
// //               <i className="ri-arrow-left-line text-xl text-white" />
// //             </button>
// //             <div>
// //               <h2 className="text-xl font-medium text-gray-900">{documentName}</h2>
// //             </div>
// //           </div>
// //         </header>

// //         <div className="relative flex-1 flex flex-col bg-gray-100">

// //           {/* Top Bar */}
// //           <header className="bg-white p-4 shadow-sm border-b border-gray-200 flex justify-between items-center">
// //             <div>
// //               <h1 className="text-xl font-medium">Document Viewer</h1>
// //               <p className="text-sm text-gray-500">{isPDF ? "PDF Document" : "File Preview"}</p>
// //             </div>
// //           </header>

// //           {/* Main Viewer Area */}
// //           <main className="relative flex-1 overflow-hidden flex items-center justify-center bg-gray-50">
// //             {/* Floating Toolbar */}
// //             {/* Loading Overlay */}
// //             {loading && (
// //               <div className="absolute inset-0 flex flex-col justify-center items-center bg-white/90 backdrop-blur-sm z-30">
// //                 <div className="w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full animate-spin mb-4"></div>
// //                 <p className="text-gray-600 font-medium">Loading document...</p>
// //               </div>
// //             )}

// //             {/* Document Container */}
// //             <div className="w-full max-w-4xl h-[85%] bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-200 relative z-10 p-4 overflow-y-auto">
// //               {/* PDF Viewer */}
// //               {isPDF && !pdfError ? (
// //                 <Document
// //                   file={documentUrl}
// //                   onLoadStart={() => setLoading(true)}
// //                   onLoadSuccess={({ numPages }) => {
// //                     setNumPages(numPages);
// //                     setLoading(false);
// //                   }}
// //                   onLoadError={() => {
// //                     setPdfError(true);
// //                     setLoading(false);
// //                   }}
// //                   renderMode="canvas"
// //                   className="flex flex-col items-center"
// //                 >
// //                   {numPages &&
// //                     Array.from(new Array(numPages), (_, index) => (
// //                       <LazyPage key={index} pageNumber={index + 1} />
// //                     ))}
// //                 </Document>
// //               ) : isPDF && pdfError ? (
// //                 <iframe
// //                   src={`https://docs.google.com/gview?url=${encodeURIComponent(
// //                     documentUrl
// //                   )}&embedded=true`}
// //                   className="w-full h-full border-none overflow-hidden"
// //                   title="PDF Viewer"
// //                   onLoad={() => setLoading(false)}
// //                 />
// //               ) : isDoc || isPpt ? (
// //                 <iframe
// //                   src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
// //                     documentUrl
// //                   )}`}
// //                   className="w-full h-full border-none overflow-hidden"
// //                   title="Office Document"
// //                   onLoad={() => setLoading(false)}
// //                 />
// //               ) : (
// //                 <a
// //                   href={documentUrl}
// //                   target="_blank"
// //                   rel="noopener noreferrer"
// //                   className="text-blue-600 underline block text-center mt-20"
// //                 >
// //                   Open Document
// //                 </a>
// //               )}

// //             </div>
// //           </main>
// //         </div>

// //         {/* Mark as Completed */}
// //         <div className="mt-6">
// //           <button
// //             onClick={handleComplete}
// //             className="px-4 py-2 text-white rounded-full bg-[#B03982]"
// //           >
// //             Mark as Completed
// //           </button>
// //         </div>
// //       </div>

// //       {/* Video Column */}
// //       <div className="w-1/3 flex flex-col justify-center items-center relative">
// //         <video
// //           src={Reading_loop}
// //           autoPlay
// //           loop
// //           muted
// //           className="w-full h-full object-cover pt-20 pr-20 pb-0"
// //         />
// //         <ChatBot dir={dir} showChat={showChat} setShowChat={setShowChat} />
// //       </div>
// //     </div>
// //   );
// // };

// // export default DocumentView;

// import React, { useCallback, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { Document, Page, pdfjs } from "react-pdf";
// import { useInView } from "react-intersection-observer";
// import ChatBot from "./ChatBot";
// import axios from "axios";
// import Reading_loop from "../../assest/Nerdy Think Read GIF/Reading_Loop.mp4";
// import { useDispatch } from "react-redux";
// import { logout } from "../../features/auth/authSlice";

// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`;

// const DocumentView = ({ dir }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const documentUrl = location.state?.docUrl || null;
//   const documentName = location.state?.name || null;
//   const courseId = location.state?.courseId || null;
//   const moduleId = location.state?.moduleId || null;
//   const indexDoc = location.state?.index;

//   const [loading, setLoading] = useState(true);
//   const [numPages, setNumPages] = useState(null);
//   const [pdfError, setPdfError] = useState(false);
//   const [showChat, setShowChat] = useState(true);

//   const handleSignOut = useCallback(() => {
//     localStorage.removeItem("user");
//     localStorage.removeItem("token");
//     localStorage.removeItem("profileData");
//     sessionStorage.removeItem("conversation");
//     sessionStorage.removeItem("currentSessionId");
//     sessionStorage.removeItem("sessionNumber");
//     sessionStorage.removeItem("sessions");
//     dispatch(logout());
//     navigate("/login");
//   }, [navigate, dispatch]);

//   const handleComplete = async () => {
//     try {
//       const base_url = process.env.REACT_APP_LMS_APP_BASE_URL;
//       const token = localStorage.getItem("token");
//       const profileData = JSON.parse(localStorage.getItem("profileData"));
//       const userId = profileData?.id;

//       const response = await axios.put(
//         `${base_url}/module/updateDocumentProgress`,
//         {
//           userId,
//           moduleId,
//           courseId,
//           documentIndex: indexDoc,
//           status: "completed",
//           timeSpent: 300,
//         },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       console.log("Document progress updated:", response.data);
//       navigate(`/lms/dashboard/module`, { state: { moduleId } });
//     } catch (error) {
//       if (error?.response?.status === 401) handleSignOut();
//       console.error("Error updating progress:", error);
//     }
//   };

//   if (!documentUrl) {
//     return (
//       <div className="text-center py-10 text-red-500">
//         No document URL provided.
//       </div>
//     );
//   }

//   const ext = documentUrl.split(".").pop().toLowerCase();
//   const isPDF = ext === "pdf";
//   const isDoc = ext === "doc" || ext === "docx";
//   const isPpt = ext === "ppt" || ext === "pptx";

//   const LazyPage = ({ pageNumber }) => {
//     const { ref, inView } = useInView({
//       threshold: 0.1,
//       triggerOnce: true,
//     });
//     return (
//       <div ref={ref} className="mb-2 flex justify-center">
//         {inView ? (
//           <Page pageNumber={pageNumber} width={700} />
//         ) : (
//           <div style={{ height: 900 }} />
//         )}
//       </div>
//     );
//   };

//   return (
//     <div dir={dir} className="flex flex-col md:flex-row h-[85vh] ml-16">
//       {/* Document Viewer */}
//       <div className="flex-1 flex flex-col">
//         <header className="bg-white/80 backdrop-blur-xl border-b border-gray-200/50 pb-6 z-10">
//           <div className="flex items-center gap-4">
//             <button
//               onClick={() => navigate(-1)}
//               style={{ backgroundColor: "#767676" }}
//               className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center transition-all duration-300 cursor-pointer"
//             >
//               <i className="ri-arrow-left-line text-xl text-white" />
//             </button>
//             <div>
//               <h2 className="text-xl font-medium text-gray-900">{documentName}</h2>
//             </div>
//           </div>
//         </header>

//         <div className="relative flex-1 flex flex-col bg-gray-100">
//           {/* Top Bar */}
//           <header className="bg-white p-4 shadow-sm border-b border-gray-200 flex justify-between items-center">
//             <div>
//               <h1 className="text-xl font-medium">Document Viewer</h1>
//               <p className="text-sm text-gray-500">
//                 {isPDF ? "PDF Document" : "File Preview"}
//               </p>
//             </div>
//           </header>

//           {/* Viewer */}
//           <main className="relative flex-1 overflow-hidden flex items-center justify-center bg-gray-50">
//             <div className="w-full max-w-4xl h-[85%] bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-200 relative z-10 p-4 overflow-y-auto">

//               {/* Loader */}
//               {loading && (
//                 <div className="absolute inset-0 flex flex-col justify-center items-center bg-white/90 backdrop-blur-sm z-30">
//                   <div className="w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full animate-spin mb-4"></div>
//                   <p className="text-gray-600 font-medium">Loading document...</p>
//                 </div>
//               )}

//               {/* PDF Viewer */}
//               {isPDF && !pdfError ? (
//                 <Document
//                   file={documentUrl}
//                   onLoadStart={() => setLoading(true)}
//                   onLoadSuccess={({ numPages }) => setNumPages(numPages)}
//                   onLoadError={() => {
//                     setPdfError(true);
//                     setLoading(false);
//                   }}
//                   renderMode="canvas"
//                   className="flex flex-col items-center"
//                 >
//                   {/* Load first page immediately */}
//                   {numPages >= 1 && (
//                     <Page
//                       pageNumber={1}
//                       width={700}
//                       onRenderSuccess={() => setLoading(false)}
//                     />
//                   )}

//                   {/* Lazy load remaining pages */}
//                   {numPages > 1 &&
//                     Array.from({ length: numPages - 1 }, (_, index) => (
//                       <LazyPage key={index + 2} pageNumber={index + 2} />
//                     ))}
//                 </Document>
//               ) : isPDF && pdfError ? (
//                 <iframe
//                   src={`https://docs.google.com/gview?url=${encodeURIComponent(
//                     documentUrl
//                   )}&embedded=true`}
//                   className="w-full h-full border-none overflow-hidden"
//                   title="PDF Viewer"
//                   onLoad={() => setLoading(false)}
//                 />
//               ) : isDoc || isPpt ? (
//                 <iframe
//                   src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
//                     documentUrl
//                   )}`}
//                   className="w-full h-full border-none overflow-hidden"
//                   title="Office Document"
//                   onLoad={() => setLoading(false)}
//                 />
//               ) : (
//                 <a
//                   href={documentUrl}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-blue-600 underline block text-center mt-20"
//                 >
//                   Open Document
//                 </a>
//               )}
//             </div>
//           </main>
//         </div>

//         {/* Mark as Completed */}
//         <div className="mt-6">
//           <button
//             onClick={handleComplete}
//             className="px-4 py-2 text-white rounded-full bg-[#B03982]"
//           >
//             Mark as Completed
//           </button>
//         </div>
//       </div>

//       {/* Video Column */}
//       <div className="w-1/3 flex flex-col justify-center items-center relative">
//         <video
//           src={Reading_loop}
//           autoPlay
//           loop
//           muted
//           className="w-full h-full object-cover pt-20 pr-20 pb-0"
//         />
//         <ChatBot dir={dir} showChat={showChat} setShowChat={setShowChat} />
//       </div>
//     </div>
//   );
// };

// export default DocumentView;


import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ChatBot from "./ChatBot";
import axios from "axios";
// import Reading_loop from "../../assest/Nerdy Think Read GIF/Reading_Loop.mp4";
import CharacterDisplay from "../CharacterDisplay";
import { t } from "i18next";
// import { useDispatch } from "react-redux";
// import { logout } from "../../features/auth/authSlice";

const DocumentView = ({ dir }) => {

  const location = useLocation();
  const navigate = useNavigate();
  // const dispatch = useDispatch();

  const documentUrl = location.state?.docUrl || null;
  const documentName = location.state?.name || null;
  const courseId = location.state?.courseId || null;
  const moduleId = location.state?.moduleId || null;
  const indexDoc = location.state?.index;

  const [loading, setLoading] = useState(true);
  const [showChat, setShowChat] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const iframeRef = useRef(null);

  useEffect(() => {
    // Reset loading when documentUrl changes
    setLoading(true);

    // Fallback: set loading to false after 10 seconds if still loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 10000);

    return () => clearTimeout(timer);
  }, [documentUrl]);

  // Add this useEffect for sidebar state management
  useEffect(() => {
    const updateSidebarState = () => {
      const sidebarState = getComputedStyle(document.documentElement).getPropertyValue('--sidebar-open');
      setSidebarOpen(sidebarState === '1');
    };

    updateSidebarState();

    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    const observer = new MutationObserver(updateSidebarState);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Calculate responsive padding based on sidebar state and screen size
  const getContentPadding = () => {
    if (isMobile) {
      return "";
    }
    return sidebarOpen
      ? (dir === 'rtl' ? 'pr-64' : 'pl-64')
      : (dir === 'rtl' ? 'pr-20' : 'pl-20');
  };

  // const handleSignOut = useCallback(() => {
  //   localStorage.removeItem("user");
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("profileData");
  //   sessionStorage.removeItem("conversation");
  //   sessionStorage.removeItem("currentSessionId");
  //   sessionStorage.removeItem("sessionNumber");
  //   sessionStorage.removeItem("sessions");
  //   dispatch(logout());
  //   navigate("/login");
  // }, [navigate, dispatch]);

  const handleComplete = async () => {
    setGenerating(true);
    try {
      const base_url = process.env.REACT_APP_LMS_APP_BASE_URL;
      const token = localStorage.getItem("token");
      const profileData = JSON.parse(localStorage.getItem("profileData"));
      const userId = profileData?.id;

      const response = await axios.put(
        `${base_url}/module/updateDocumentProgress`,
        {
          userId,
          moduleId,
          courseId,
          documentIndex: indexDoc,
          status: "completed",
          timeSpent: 300,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log("Document progress updated:", response.data);
      setGenerating(false);
      navigate(`/lms/course`, { state: { moduleId } });
    } catch (error) {
      setGenerating(false);
      // if (error?.response?.status === 401) handleSignOut();
      console.error("Error updating progress:", error);
    }
  };

  if (!documentUrl) {
    return (
      <div className="text-center py-10 text-red-500">
        No document URL provided.
      </div>
    );
  }

  const ext = documentUrl.split(".").pop().toLowerCase();
  const isPDF = ext === "pdf";
  const isDoc = ext === "doc" || ext === "docx";
  const isPpt = ext === "ppt" || ext === "pptx";

  return (
    <div dir={dir} className={`flex flex-col md:flex-row h-[84vh] m-4 transition-all duration-300 ${getContentPadding()}`}>
      {/* Document Viewer */}
      <div className="flex-1 flex flex-col">
        <header className="bg-white/80 backdrop-blur-xl border-b border-gray-200/50 pb-6 z-10">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate(-1)}
              style={{ backgroundColor: "#767676" }}
              className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl text-white" />
            </button>
            <div>
              <h2 className="text-xl font-medium text-gray-900">{documentName}</h2>
            </div>
          </div>
        </header>

        <div className="relative flex-1 flex flex-col bg-gray-100">
          {/* Top Bar */}
          {/* <header className="bg-white p-4 shadow-sm border-b border-gray-200 flex justify-between items-center">
            <div>
              <h1 className="text-xl font-medium">Document Viewer</h1>
              <p className="text-sm text-gray-500">File Preview</p>
            </div>
          </header> */}

          {/* Viewer */}
          <main className="relative flex-1 overflow-hidden flex items-center justify-center bg-gray-50">
            <div className="w-full h-[90%] bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-200 relative z-10 overflow-y-auto mx-6">

              {/* Loader */}
              {loading && (
                <div className="absolute inset-0 flex flex-col justify-center items-center bg-white/90 backdrop-blur-sm z-30">
                  <div className="w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full animate-spin mb-4"></div>
                  <p className="text-gray-600 font-medium">Loading document...</p>
                </div>
              )}

              {/* Document Viewer */}
              {/* {isPDF ? (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    documentUrl
                  )}&embedded=true`}
                  className="w-full h-full border-none overflow-hidden"
                  title="PDF Viewer"
                  onLoad={() => setLoading(false)}
                />
              ) : isDoc || isPpt ? (
                <iframe
                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                    documentUrl
                  )}`}
                  className="w-full h-full border-none overflow-hidden"
                  title="Office Document"
                  onLoad={() => setLoading(false)}
                />
              ) : (
                <a
                  href={documentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline block text-center mt-20"
                >
                  Open Document
                </a>
              )} */}

              {isPDF ? (
                <div className="relative w-full h-full">
                  <iframe
                    ref={iframeRef}
                    src={`${documentUrl}#page=1&view=FitH`}
                    className="w-full h-full border-none"
                    title="PDF Viewer"
                    onLoad={() => setLoading(false)}
                  />

                  {/* Fullscreen button */}
                  <button
                    onClick={() => iframeRef.current?.requestFullscreen()}
                    className="absolute bottom-4 right-8 z-50 bg-black/70 text-white px-3 py-1 rounded"
                  >
                    ⛶
                  </button>
                </div>

              ) : isDoc || isPpt ? (
                <iframe
                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                    documentUrl
                  )}`}
                  className="w-full h-full border-none overflow-hidden"
                  title="Office Document"
                  allowFullScreen={true}
                  onLoad={() => setLoading(false)}
                />
              ) : (
                <a
                  href={documentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline block text-center mt-20"
                >
                  Open Document
                </a>
              )}

            </div>
          </main>
        </div>

        {/* Mark as Completed */}
        <div className="mt-6 flex justify-end">
          <button
            onClick={handleComplete}
            className="px-4 py-2 text-white rounded-full bg-[#B03982]"
          >
            {generating ? t("Verifying...") : t("Mark as Completed")}
          </button>
        </div>
      </div>

      {/* Video Column */}
      <div className="w-1/3 flex flex-col justify-center items-center relative">
        <div className="absolute bottom-0 right-0 hidden md:flex flex-col items-center space-y-4">
          <div className="w-[12rem] h-[18rem]">
            <CharacterDisplay loading={loading} />
          </div>
        </div>
      </div>
      <ChatBot dir={dir} showChat={showChat} setShowChat={setShowChat} />
    </div>
  );
};

export default DocumentView;
